import script from "./Messages.vue?vue&type=script&lang=ts&setup=true"
export * from "./Messages.vue?vue&type=script&lang=ts&setup=true"

import "./Messages.vue?vue&type=style&index=0&id=78be98cc&lang=scss&scoped=true"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78be98cc"]])

export default __exports__